<template>
    <div class="notFound">
        <div class="notFound-img">
            <img class="notFound-img-detail" src="../../assets/img/notFound/404.png" alt="404 not Found">
        </div>
        <div class="notFound-content f24">Error，页面出错啦！！   请点击返回首页或者返回上一页面~</div>
        <div class="notFound-btn">
          <a></a>
          <a class="notFound-link" href="/">
            <el-button class="notFound-button" round>返回首页</el-button>
          </a>
          <a class="notFound-link" @click="goPrev">
            <el-button class="notFound-button" round>返回上一页</el-button>
          </a>
        </div>
    </div>
</template>
<script>
export default {
  name: 'NotFound',
  metaInfo () {
    return {
      title: this.$seo.notfound.title, // set a title
      meta: [{ // set meta
        name: 'keywords',
        content: this.$seo.notfound.keywords
      },
      {
        name: 'description',
        content: this.$seo.notfound.description
      }]
    }
  },
  data () {
    return {
      prevUrl: '' // 上一页url
    }
  },
  methods: {
    goIndex () {
      this.$router.push('/index')
    },
    goPrev () {
      window.history.go(-2)
    }
  },
  mounted () {
  }
}
</script>
<style lang="scss">
.notFound{
    width: 100%;
    height: 100%;
    padding-top:6%;
  .notFound-img{
     width: 33%;
    height: 44%;
    margin: 0 auto;
    .notFound-img-detail{
      width: 100%;
      height: 100%;
    }
  }
  .notFound-content{
    text-align: center;
    font-family:MicrosoftYaHei;
    font-weight:400;
    color:rgba(51,51,51,1);
    margin-top: 3.5%;
    margin-bottom: 3%;
  }
  .notFound-btn{
    text-align: center;
    .notFound-button{
      width: 140px;
      height: 40px;
      background-color: transparent;
      color: #666666;
    }
    .notFound-button:hover,
    .notFound-button:focus {
      background-color: #6C63FF;
      color: #ffffff;
    }
    .notFound-link:last-child {
      margin-left: 170px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// notFound.vue?c3c09950